import { Conjunt } from "./conjunt.model";

export class Bloc {
    conjunts: Array<Conjunt> = [];
    descripcio: string;
    id: number;
    
    opened: boolean;
}